export const getShipDefaultFilterOptions = () => {
  return {
    year: new Date().getFullYear().toString(),
    month: [],
    region: [],
    portOfCall: [],
  }
}
